import React, { useEffect, useState } from 'react';
import { ModalNotAllowedProps } from '../type';
import closeBtn from '../../assets/close.svg';
import ModalFacebookNotAllowed from 'react-modal';
import { redirectToMyPrevisite } from '../../service/authService';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

const ModalNotAllowed: React.FC<ModalNotAllowedProps> = ({ isLoading, setShowIfNotAllowed }) => {
    const [showInfoModal, setShowInfoModal] = useState(false);
    const closeInfoModal = () => {
        setShowInfoModal(false);
        setShowIfNotAllowed(false);
    };
    const userId = useSelector((state: RootState) => state.user.userMyId);

    const handleRedirect = () => {
        redirectToMyPrevisite(userId);
    };

    useEffect(() => {
        setShowInfoModal(true);
    }, []);

    if (isLoading) {
        return null;
    }

    return (
        <>
            <ModalFacebookNotAllowed
                id="root"
                className="flex"
                isOpen={showInfoModal}
                onRequestClose={closeInfoModal}
                contentLabel="Information"
            >
                <div className="flex flex-col items-center gap-6 p-8 rounded-[24px] bg-[var(--generic-white)] relative m-auto">
                    <span onClick={closeInfoModal}>
                        <img src={closeBtn} alt="Fermer la fenêtre" className="w-[12px] h-[12px]" />
                    </span>
                    <div className="my-5 text-[var(--text-heavy-font-size)] font-[var(--text-super-heavy-font-weight)]">
                        <h3>Informations</h3>
                    </div>
                    <div className="modal-info-content">
                        <p className="text-dark-gray text-medium font-medium leading-[120%]">
                            Vous ne disposez pas des autorisations nécessaires pour répondre aux
                            avis Facebook.
                        </p>
                        <p className="info-2 text-gray text-medium font-small leading-[120%]">
                            Veuillez vous rendre sur{' '}
                            <a className={'link-my-previsite'} href="/#" onClick={handleRedirect}>
                                my.previsite.com
                            </a>
                            , onglet "Community Management", pour vous déconnecter puis vous
                            reconnecter à Facebook. Cela permettra de valider les autorisations
                            requises.
                            <br />
                            <br />
                            Une fois cette étape effectuée, vous pourrez répondre aux avis
                            directement depuis votre interface News Factory.
                        </p>
                    </div>
                    <div className="modal-buttons">
                        <button
                            onClick={closeInfoModal}
                            className="
                              close-button
                              flex
                              w-[160px]
                              px-[40px] py-[10px]
                              justify-center
                              items-center
                              gap-1.5
                              rounded-[40px]
                              bg-primary
                              text-medium
                              font-medium
                              leading-[20px]
                            "
                        >
                            Fermer
                        </button>
                    </div>
                </div>
            </ModalFacebookNotAllowed>
        </>
    );
};

export default ModalNotAllowed;
